import {
  combineReducers,
  configureStore,
  createAction,
  StateFromReducersMapObject,
} from "@reduxjs/toolkit";
import { animalsReducer } from "./slices/animals";
import { customerReducer } from "./slices/customer";
import { metadataReducer } from "./slices/metadata";
import { navigationMiddleware } from "./middlewares/navigation";
import { navigationReducer } from "./slices/navigation";
import { State } from "./state/types";
import { getInitialState } from "./state";
import { analyticsMiddleware } from "./middlewares/analytics";
import { resetMiddleware } from "./middlewares/reset";
import { upsertDraftMiddleware } from "./middlewares/upsertDraft";
import { animalsMiddleware } from "./middlewares/animals";

const reducer = {
  animals: animalsReducer,
  customer: customerReducer,
  metadata: metadataReducer,
  navigation: navigationReducer,
};

const appReducer = combineReducers({
  animals: animalsReducer,
  customer: customerReducer,
  metadata: metadataReducer,
  navigation: navigationReducer,
});

export const resetAction = createAction("global/reset");

const rootReducer = (state: State | undefined, action: any): State => {
  if (action.type === resetAction.type) {
    return appReducer(getInitialState(), action);
  }
  return appReducer(state, action);
};

export type RootState = StateFromReducersMapObject<typeof reducer>;

export const createStore = (preloadedState: RootState) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        navigationMiddleware,
        analyticsMiddleware,
        resetMiddleware,
        upsertDraftMiddleware,
        animalsMiddleware
      ),
  });

export type SignupStore = ReturnType<typeof createStore>;
export type SignupDispatch = SignupStore["dispatch"];
